<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/649cgy/tc-custom/9780374711917.jpg?1731159410425" alt="This image is the cover for the book This Close to Happy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Close to Happy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A cleareyed, insightful account of how she felt during her nosedives into despair . . . shot through with a self-awareness that helps readers cheer her on.”—<i>The New York Times</i></b><br/>  <br/><i>A New York Times Book Review Favorite Read of the Year</i><br/>  <br/> “Despair is always described as dull,” writes Daphne Merkin, “when the truth is that despair has a light all its own, a lunar glow, the color of mottled silver.” <i>This Close to Happy</i>—Merkin’s rare, vividly personal account of what it feels like to suffer from clinical depression—captures this strange light.<br/>  <br/> Merkin has been hospitalized three times: first, in grade school, for childhood depression; years later, after her daughter was born, for severe postpartum depression; and later still, after her mother died, for obsessive suicidal thinking. Recounting this series of hospitalizations, as well as her visits to myriad therapists and psychopharmacologists, Merkin portrays the lifelong arc of her affliction, beginning in a childhood largely bereft of love and stretching into the present, where she lives a high-functioning life and her depression is manageable, if not “cured.” The opposite of depression, she writes with characteristic insight, is not a state of unimaginable happiness, but a state of relative all-right-ness.<br/>  <br/> In this dark yet vital memoir, Merkin describes not only the harrowing sorrow that she has known all her life, but also her early, redemptive love of reading and gradual emergence as a writer. Written with an acute understanding of the ways in which her condition has evolved as well as affected those around her, <i>This Close to Happy</i> is an utterly candid coming-to-terms with an illness that is still often stigmatized and shrouded in misunderstanding.<br/>  <br/> “[A] mesmerizing memoir.” —<i>Booklist</i> (starred review)<br/>  <br/> “Brings a stunningly perceptive voice to the forefront of the conversation about depression, one that is both reassuring and revelatory.” —Carol Gilligan, author of <i>In a Different Voice</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daphne Merkin
      </h2>
      
      <p class="authorDescription body article"><B>DAPHANE MERKIN</B>'s writing frequently appears in <I>The New York Times, Bookforum, Departures, Travel + Leisure, W, Vogue, Tablet Magazine</I>, and other publications. She is a former staff writer for <I>The New Yorker </I>and <I>The New York Times</I> and a regular contributor to <I>ELLE</I>. Merkin has taught writing at the 92nd Street Y, Marymount College, and Hunter College. Her previous books include <I>Enchantment</I>, which won the Edward Lewis Wallant Award for best novel on a Jewish theme, and two collections of essays, <I>Dreaming of Hitler </I>and <I>The Fame Lunches</I>, which was a <I>New York Times</I> Notable Book of the Year. She lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?432f3db0